import { InternalLink } from '../../Clickables/InternalLink/InternalLink';
import { ArrowRightIcon } from '../../Icons/ArrowRightIcon';

interface IProps {
  blogSlug: string;
  authorNickname: string;
}

export const BlogAuthorLink = ({ blogSlug, authorNickname }: IProps) => (
  <InternalLink
    variant="buttonTertiary"
    to={`/blog/authors/${blogSlug}`}
    className="bg-sea-foam! flex gap-2 p-4"
  >
    <span className="line-clamp-1 break-all text-ellipsis">{`Blog posts by ${authorNickname}`}</span>
    <ArrowRightIcon size={20} className="min-w-5" />
  </InternalLink>
);
